import { render, staticRenderFns } from "./bind-mobile.vue?vue&type=template&id=3dd97004&scoped=true"
import script from "./bind-mobile.vue?vue&type=script&lang=js"
export * from "./bind-mobile.vue?vue&type=script&lang=js"
import style0 from "./bind-mobile.vue?vue&type=style&index=0&id=3dd97004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd97004",
  null
  
)

export default component.exports